import { portalCustomizationDisabledRouteHandle } from "@redotech/redo-customer-portal-app/customization/customization-context";
import { RouteObject } from "react-router-dom";

/**
 * All order tracking iframe routes
 */
export const orderTrackingIframeRoutes: RouteObject[] = [
  // Kuru tracking iframe
  {
    path: "kuru-tracking-iframe",
    handle: portalCustomizationDisabledRouteHandle,
    lazy: async () => {
      const { KuruTrackingIframeRoot } = await import("./kuru-tracking-iframe");
      return { Component: KuruTrackingIframeRoot };
    },
  },
  {
    path: "jack-archer-tracking-iframe",
    handle: portalCustomizationDisabledRouteHandle,
    lazy: async () => {
      const { JackArcherTrackingIframeRoot } =
        await import("./jack-archer-tracking-iframe");
      return { Component: JackArcherTrackingIframeRoot };
    },
  },
  {
    path: "embedded-tracking/:fulfillmentIndex?",
    handle: portalCustomizationDisabledRouteHandle,
    lazy: async () => {
      const { EmbeddedTrackingRoot } = await import("./embedded-tracking");
      return { Component: EmbeddedTrackingRoot };
    },
  },
];
